import React, {useEffect, useState} from 'react'
import {Col, Row, Select, Typography} from "antd";
import {
    CalendarOutlined,
    DollarCircleOutlined,
    FieldTimeOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined,
} from "@ant-design/icons";

const {Title, Text} = Typography
const {Option} = Select

function ArtworkSortButton(props) {

    const [defaultValue, setDefaultValue] = useState(props.order ?? 'Sort By')
    useEffect(()=>{
        setDefaultValue(props.order ?? 'Sort By')
    }, [props.order])

    return (
        <Row data-tut="reactour__sort" align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{minWidth: 320}}>
            <Col>
                <Title level={4} style={{marginBottom: 0}}>
                    <SortAscendingOutlined/> Sort
                </Title>
            </Col>
            <Col>
                <Select
                    defaultValue={defaultValue}
                    dropdownMatchSelectWidth={false}
                    listHeight={512}
                    onChange={(value) => {
                        if (props.onChange)
                            props.onChange(value)
                    }}
                >
                    <Option value='name'>
                        <SortAscendingOutlined/> Title (a-z)
                    </Option>
                    <Option value='-name'>
                        <SortDescendingOutlined/> Title (z-a)
                    </Option>
                    <Option value='price_type_str'>
                        <DollarCircleOutlined/> Price (low)
                    </Option>
                    <Option value='-price_type_str'>
                        <DollarCircleOutlined/> Price (high)
                    </Option>
                    <Option value='-year'>
                        <CalendarOutlined/> Creation Year(recent)
                    </Option>
                    <Option value='year'>
                        <CalendarOutlined/> Creation Year(old)
                    </Option>
                    <Option value='-created_at'>
                        <FieldTimeOutlined/> Date Added (recent)
                    </Option>
                    <Option value='created_at'>
                        <FieldTimeOutlined/> Date Added (old)
                    </Option>
                    <Option value='-updated_at'>
                        <FieldTimeOutlined/> Last Updated (recent)
                    </Option>
                    <Option value='updated_at'>
                        <FieldTimeOutlined/> Last Updated (old)
                    </Option>
                </Select>
            </Col>
        </Row>
    )
}

export default ArtworkSortButton